module.exports = __webpack_public_path__ + "img/kerala-gov.c2e31f85.jpg";